<template>
    <div class="doshi_box">
        <div class="key_topTit">
            <div class="backBox" @click="back">
                <i class="el-icon-back myback_icon"></i> Back
            </div>
            <div class="search">
                <input type="text" @input="searchList" v-model="keyWord" />
            </div>
        </div>
        <div class="titbox">
            Please select the Peiso venue you want to connect to
        </div>
        <div style="margin-bottom:30px">
			<el-table
			:data="tableData"
			class="roster_table venue-table"
			style="width: 100%">
				<el-table-column
				prop="venueName"
				align="center"
				label-class-name="roster_th"
				class-name="roster_row"
				label="VENUE NAME">
				</el-table-column>
				<el-table-column
				align="center"
                prop="venueOwner"
				label-class-name="roster_th"
				class-name="roster_row"
				label="USERNAME">
				</el-table-column>
				<el-table-column
				align="center"
                prop='venueMobile'
				label-class-name="roster_th"
				class-name="roster_row"
				label="CONTACT NUMBER">
				</el-table-column>
				<el-table-column
				align="center"
				label-class-name="roster_th"
				class-name="roster_row"
                prop="venueOwner"
				label="VENUE OWNER">
				</el-table-column>
				<el-table-column
				align="center"
				label-class-name="
                "
				class-name="roster_row"
				label="VENUE ADDRESS">
				</el-table-column>
				<el-table-column
				align="center"
				label-class-name="roster_th"
				class-name="roster_row"
				label="OPERATION">
					<template slot-scope="scope">
                        <div class="key_tableBtn_group">
                            <div class="key_delBtn" @click="toConnect(scope.row.id)">Connect</div>
                        </div>
					</template>
				</el-table-column>
                <template slot="empty">
                    <i v-if="loading" class="el-icon-loading" style="font-size:20px"></i>
                    <div v-else>-</div>
                </template>
			</el-table>
			<div class="ros_footerPage">
				<el-pagination
					class="my_pageSel"
                    :current-page.sync="page"
                    @current-change='changePage'
					layout="prev, pager, next"
					:page-size="10"
					:total="total">
				</el-pagination>
			</div>
		</div>
    </div>
</template>

<script>
import api from '../../api/dishi.js'

export default {
    data() {
        return {
            tableData:[1,2,3,4,5], // 主体表格
            page: 1,
            size: 10,
            total: 0,
            loading: true, // 主体表格加载
            keyWord:'',
            timeout:null
        }
    },
    methods: {
        back(){
            this.$router.go(-1)
        },
        searchList() {
            if (this.timeout) {
                clearTimeout(this.timeout)
            }
            this.timeout = setTimeout(() => {
                this.pageNum = 1
                this.getLists.call(this)
            }, 2000) 
        },
        getLists(){
            api.getVenueList(
                {
                    pageNum: this.page,
                    pageSize: this.size,
                    keyword: this.keyWord
                },
                this.listCallback
            )
        },
        changePage(page){
            this.page=page
            this.getLists()
        },
        toConnect(id) { // 链接
            // api.deleteKeywords({params:{id:id},callback:res=>{
            //     let {code,message,data}=res.data;
            //     if(code==0){
            //         this.getLists()
            //     }else{
            //         this.$box.alert('', res.data.message, 'error')
            //     }
            // }})
        },
        // 列表回调
        listCallback (res) {
            this.loading = false
            if (res.data.code == 0) {
                res.data.data.list.forEach(item => {
                    item.createTime = this.$box.timestampToTime(item.createTime)
                    item.venueMobile = this.$box.formatNumber(item.venueMobile)
                    item.monthlyFee = Utils.formatSplit(item.monthlyFee)
                })
                this.total = res.data.data.total
                this.tableData = res.data.data.list
            } else {
                this.$box.alert('', res.data.message, 'error')
            }
        }
    },
    mounted () {
        this.getLists()
    }
}
</script>

<style lang="scss">
    .doshi_box{
        .key_topTit{
            display: flex;
            height:33px;
            font-size:24px;
            font-weight:600;
            color:rgba(255,255,255,1);
            line-height:33px;
            -webkit-text-stroke:1px rgba(255,255,255,1);
            margin-bottom: 40px;
            .backBox{
                display: flex;
                height: 33px;
                align-items: center;
                font-size: 14px;
                font-weight: 600;
                color: #FFFFFF;
                margin-bottom: 56px;
                width: 100px;
                cursor: pointer;
            }
            .search{
                margin-left: auto;
                width: 300px;
                border-bottom: 1px solid #fff;
                background-size: 24px 22px;
                background-position: left center;
                background-repeat: no-repeat;
                background-image: url('../../assets/s.png');
                margin-top: -3px;
                input{
                    outline: none;
                    border: none;
                    line-height: 30px;
                    font-size: 16px;
                    font-family:'PingFangSC-Regular,PingFang SC';
                    width: 100%;
                    background-color: transparent;
                    color: #fff;
                    box-sizing: border-box;
                    padding-left: 30px;
                }
            }
        }
        .titbox{
            width: 616px;
            height: 33px;
            font-size: 24px;
            font-weight: 600;
            color: #FFFFFF;
            line-height: 33px;
            -webkit-text-stroke: 1px #FFFFFF;
            // text-stroke: 1px #FFFFFF;
            margin-bottom: 30px;
        }
		.ros_footerPage{
			display: flex;
			justify-content: center;
        }
        .key_tableBtn_group{
            display: flex;
            justify-content: center;
        }
        .key_delBtn{
            width:100px;
            height:40px;
            background:rgba(21,28,39,1);
            border:1px solid #fff;
            font-size:18px;
            text-align: center;
            line-height: 40px;
            color: #fff;
            cursor: pointer;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/doshi/connetVenue.vue